<template>
  <div v-if="editMode">
    <div class="field-row">
      <label>Options (one per line)</label>
      <textarea
        v-model="field.multiChoiceOptions"
        class="form-control"
        rows="5"
        placeholder="Option 1&#10;Option 2&#10;Option 3">
      </textarea>
    </div>
    <div class="field-row">
      <div class="checkbox">
        <label>
          <input type="checkbox" v-model="field.allowMultipleValues" />  Allow multiple selections
        </label>
      </div>
    </div>
    <div class="field-row text-right">
      <div class="checkbox">
        <label>
          <input type="checkbox" v-model="field.required" /> Required
        </label>
      </div>
    </div>
  </div>
  <div v-else>
    <div class="vf-field-label">{{ field.fieldName }}</div>
  </div>
</template>

<script>
  export default {
    name: 'MultipleChoiceField',
    props: {
      field: {
        type: Object,
        required: true,
      },
      editMode: {
        type: Boolean,
        default: false
      },
    },
    mounted() {
      // Set default values if not already set
      if (this.field.allowMultipleValues === undefined) {
        this.field.allowMultipleValues = false;
      }

    },
    data() {
      return {
        field: this.field
      };
    },
    methods: {

    },
  };
</script>

<style scoped>
  label {
    display: block;
    margin-bottom: 5px;
    font-weight: 500;
  }

  label input[type="checkbox"] {
    margin-right: 5px;
    vertical-align: middle;
  }
</style>
